import { defineComponent as _defineComponent } from 'vue'
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import { BaseUserWithRole, User } from '@/models/User';
import { BannerUserState } from '@/models/UserState';
import store from '@/store';
import { computed, PropType, toRefs } from 'vue';
import useUser from '@/mixins/useUser';
import { templateRef } from '@vueuse/core';
import useQuickInfo from '@/state/quickInfo';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXUserBannerSimple',
  props: {
  size: {
    type: Number as PropType<120 | 60 | 50 | 40 | 32 | 26>,
    default: 120,
  },
  showOnlineIndicator: {
    type: Boolean,
    default: false
  },
  showCookies: {
    type: Boolean,
    default: false
  },
  userId: {
    type: String,
    default: ''
  },
  user: {
    type: Object as PropType<BaseUserWithRole | null>,
    default: null
  },
  clickable: {
    type: Boolean,
    default: true
  },
  isQuickInfo: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props;



const {
  size, userId, clickable
} = toRefs(props);

const el = templateRef<HTMLElement>('el');
const { showQuickInfo } = useQuickInfo();

const viewUser = computed<BannerUserState & User>(() => props.user ?? store.getters['userStates/getUserInfo']((userId.value ?? 'user')));

const hasUserId = computed(() => userId.value || viewUser.value?.userId);

const { displayName } = useUser(viewUser);

const onClick = () => {
  if (clickable.value) {
    showQuickInfo(el, viewUser.value);
  }
};

return { __sfc: true,props, size, userId, clickable, el, showQuickInfo, viewUser, hasUserId, displayName, onClick, BCXAvatar }
}

})